<template>
  <div>
    <!-- 搜索区域：分类下拉 + 名称搜索 + 查询/重置 + 新增 -->
    <div class="searchArea">
      <a-select v-model:value="currentCategory" style="width: 200px; margin-right: 10px;"
        @change="handleCategoryChange">
        <a-select-option v-for="item in categoryList" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>

      <a-input v-model:value="searchName" :placeholder="namePlaceholder" style="width: 260px; margin-right: 10px;"
        allowClear @pressEnter="fetchData" />

      <a-button type="primary" shape="circle" @click="fetchData">
        <template #icon>
          <SearchOutlined />
        </template>
      </a-button>
      <a-button style="margin-left: 10px" @click="resetSearch">重置</a-button>

      <a-button type="primary" style="margin-left: 20px" @click="showAddModal">
        <template #icon>
          <PlusOutlined />
        </template>
        新增{{ currentConfig.addLabel }}
      </a-button>
    </div>

    <!-- 当前分类说明 -->
    <div class="category-desc">{{ currentConfig.desc || '' }}</div>

    <a-table class="ant-table-striped" :columns="columns" :data-source="data" :loading="loading"
      :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="id"
      :pagination="{ pageSize: 12 }">

      <template #name="{ record }">
        <a v-if="isEnterprise" class="enterprise-link" @click="showEnterpriseImage(record)">{{ record.name || '--'
          }}</a>
        <span v-else>{{ record.name || '--' }}</span>
      </template>

      <template #imageUuid="{ record }">
        <div v-if="imageUuidOf(record)" class="thumbnail-wrapper">
          <a-image :src="thumbnailUrl + imageUuidOf(record)" :width="50" :height="50" :preview="!isEnterprise"
            :style="{ objectFit: 'cover', borderRadius: '4px', cursor: isEnterprise ? 'pointer' : 'default' }" alt="缩略图"
            @click="isEnterprise && showEnterpriseImage(record)" />
        </div>
        <span v-else>无图片</span>
      </template>

      <!-- 当跳转类型为“查看商品”时：产品图片与名称分列展示 -->
      <template #productImage="{ record }">
        <div v-if="record.product" class="product-thumb-wrapper">
          <a-image v-if="record.product.thumbnailUuid" :src="thumbnailUrl + record.product.thumbnailUuid" :width="40"
            :height="40" :style="{ objectFit: 'cover', borderRadius: '4px' }" alt="商品图" />
          <span v-else class="product-thumb-placeholder">无图</span>
        </div>
        <span v-else>--</span>
      </template>

      <template #productName="{ record }">
        <span>{{ (record.product && record.product.name) || '--' }}</span>
      </template>

      <template #operation="{ record, index }">
        <div class="flex_sa">
          <template v-if="isSortable">
            <a @click="moveRow(index, -1)" :class="{ 'is-disabled': index === 0 }" style="margin-right: 8px;">
              <ArrowUpOutlined />
            </a>
            <a @click="moveRow(index, 1)" :class="{ 'is-disabled': index === data.length - 1 }"
              style="margin-right: 8px;">
              <ArrowDownOutlined />
            </a>
          </template>

          <template v-if="isEnterprise">
            <a-tooltip title="查看大图">
              <a @click="showEnterpriseImage(record)" style="margin-right: 8px;">
                <EyeOutlined />
              </a>
            </a-tooltip>
          </template>

          <a-tooltip title="编辑">
            <a @click="showEditModal(record)">
              <FormOutlined />
            </a>
          </a-tooltip>

          <a-popconfirm title="确定要删除此条记录吗？" @confirm="handleDelete(record)" ok-text="确认" cancel-text="取消">
            <a-tooltip title="删除" style="margin-left: 8px;">
              <a class="text_danger">
                <DeleteOutlined />
              </a>
            </a-tooltip>
          </a-popconfirm>
        </div>
      </template>
    </a-table>

    <MallSettingModal v-model:visible="addVisible" :record="{}" :category="currentCategory"
      :category-config="currentConfig" @ok="handleSuccess" />
    <MallSettingModal v-model:visible="editVisible" :record="selectedRecord" :category="currentCategory"
      :category-config="currentConfig" @ok="handleSuccess" />
  </div>
</template>
<script>
import { SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined, EyeOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import { GetMallSettingList, DeleteMallSetting, SaveMallSettingOrder } from "/src/api/shopping.js";
import MallSettingModal from "../../components/shopping/MallSettingModal.vue";

export default {
  name: "商城配置管理",
  components: {
    SearchOutlined, FormOutlined, DeleteOutlined, PlusOutlined,
    ArrowUpOutlined, ArrowDownOutlined, EyeOutlined,
    MallSettingModal,
  },
  data() {
    return {
      // 分类选项
      categoryList: [
        { value: 'Banner', label: 'Banner', desc: 'banner（顶部轮播图）', linkType: '查看商品', addLabel: 'Banner', nameLabel: 'Banner 名称', valueLabel: '产品编号', imageLabel: 'Banner 图片', showValue: false, sortable: false, isEnterprise: false, showProduct: true },
        { value: '促销品类', label: '促销品类', desc: '金刚区', linkType: '商品列表', addLabel: '促销品类', nameLabel: '品类名称', valueLabel: '分类', imageLabel: '品类图片', showValue: true, sortable: true, isEnterprise: false },
        { value: '商城产品类别', label: '商城产品类别', desc: '商品分类', linkType: '商品列表', addLabel: '商城产品类别', nameLabel: '类别名称', valueLabel: '分类', imageLabel: '类别图片', showValue: true, sortable: true, isEnterprise: false },
        { value: '企业资质', label: '企业资质', desc: '企业资质列表', linkType: '查看大图', addLabel: '企业资质', nameLabel: '资质名称', valueLabel: '', imageLabel: '企业资质照片', showValue: false, sortable: false, isEnterprise: true },
      ],
      currentCategory: 'Banner',
      searchName: undefined,
      data: [],
      loading: false,
      addVisible: false,
      editVisible: false,
      selectedRecord: {},
      imageUrl: '/api/file/img/', // 原图
      thumbnailUrl: '/api/file/img/thumbnail/', // 缩略图
    };
  },
  computed: {
    // 当前选中分类的配置
    currentConfig() {
      return this.categoryList.find(item => item.value === this.currentCategory) || {};
    },
    isEnterprise() {
      return !!this.currentConfig.isEnterprise;
    },
    isSortable() {
      return !!this.currentConfig.sortable;
    },
    namePlaceholder() {
      return '请输入' + (this.currentConfig.nameLabel || '名称');
    },
    // 动态列：名称 / 图片 / value(视分类) / 顺序(可排序) / 操作
    columns() {
      const config = this.currentConfig;
      const cols = [
        { title: '名称', dataIndex: 'name', key: 'name', width: '25%', slots: { customRender: 'name' } },
        { title: '图片', dataIndex: 'imageUuid', key: 'imageUuid', width: '15%', slots: { customRender: 'imageUuid' } },
      ];
      if (config.showValue) {
        cols.push({ title: config.valueLabel || 'value', dataIndex: 'value', key: 'value', width: '15%' });
      }
      // 跳转商品（查看商品）时展示所链接产品信息（图片与名称分列）
      if (config.showProduct || this.data.some(item => item.product)) {
        cols.push({ title: '产品图片', key: 'productImage', width: '10%', slots: { customRender: 'productImage' } });
        cols.push({ title: '产品名称', dataIndex: ['product', 'name'], key: 'productName', width: '15%', slots: { customRender: 'productName' } });
      }
      if (this.isSortable) {
        cols.push({ title: '顺序', dataIndex: 'orderIndex', key: 'orderIndex', width: '10%' });
      }
      cols.push({ title: '操作', key: 'operation', width: '25%', slots: { customRender: 'operation' } });
      return cols;
    },
  },
  watch: {
    // 切换 category 时自动刷新列表
    currentCategory() {
      this.fetchData();
    },
  },
  mounted() {
    this.fetchData();
  },

  methods: {
    // 分类切换回调：自动刷新列表（通过 watch currentCategory 已自动触发）
    handleCategoryChange() {
    },

    // 列表查询
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          excludeEmpty: true,
          category: this.currentCategory,
          includeProduct:true,
        };
        if (this.searchName) {
          params.name = this.searchName;
        }
        const res = await GetMallSettingList(params);
        if (res.errCode === 0) {
          // 前端手动添加序号
          this.data = (res.data || []).map((item, index) => ({
            ...item,
            orderIndex: index + 1,
          }));
        } else {
          message.error(res.errMsg || "查询失败");
        }
      } catch (error) {
        console.error("Search error:", error);
        message.error("请求异常，请稍后重试");
      } finally {
        this.loading = false;
      }
    },

    // 重置搜索
    resetSearch() {
      this.searchName = undefined;
      this.fetchData();
    },

    // 显示新增弹窗
    showAddModal() {
      this.addVisible = true;
    },

    // 显示编辑弹窗
    showEditModal(record) {
      this.selectedRecord = { ...record };
      console.log(record);
      
      this.editVisible = true;
    },

    // 弹窗成功回调：刷新列表
    handleSuccess() {
      this.fetchData();
    },

    // 删除操作
    async handleDelete(record) {
      try {
        const res = await DeleteMallSetting({ id: record.id });
        if (res.errCode === 0) {
          message.success("删除成功");
          this.fetchData();
        } else {
          message.error(res.errMsg || "删除失败");
        }
      } catch (error) {
        console.error("Delete error:", error);
        message.error("请求异常，请稍后重试");
      }
    },

    // 上移/下移（仅促销品类、商城产品类别）
    moveRow(index, direction) {
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= this.data.length) {
        return;
      }
      const temp = this.data[index];
      this.data.splice(index, 1);
      this.data.splice(targetIndex, 0, temp);

      this.data.forEach((item, idx) => {
        item.orderIndex = idx + 1;
      });
      this.saveRowOrder();
    },

    // 保存新的行顺序到后端
    async saveRowOrder() {
      const idOrder = this.data.map(item => item.id).filter(id => id);
      if (idOrder.length === 0) {
        message.warning('没有可排序的数据ID');
        return;
      }
      try {
        const res = await SaveMallSettingOrder(idOrder);
        if (res.errCode !== 0) {
          message.error(res.errMsg || '保存排序失败');
          this.fetchData();
        }
      } catch (error) {
        console.error("SaveMallSettingOrder error:", error);
        message.error("请求异常，保存排序失败");
        this.fetchData();
      }
    },

    // 获取表格展示用的图片 uuid（企业资质取 value）
    imageUuidOf(record) {
      return (record && record.imageUuid) || (this.isEnterprise ? (record && record.value) : '') || '';
    },

    // 企业资质：在新标签页展示完整图片
    showEnterpriseImage(record) {
      const uuid = this.imageUuidOf(record);
      if (uuid) {
        window.open(this.imageUrl + uuid, '_blank');
      } else {
        message.warning('暂无图片');
      }
    },
  },
};
</script>


<style scoped>
.searchArea {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.category-desc {
  color: #999;
  font-size: 12px;
  margin-bottom: 12px;
}

.thumbnail-wrapper {
  width: 50px;
  height: 50px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 4px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.flex_sa {
  display: flex;
  align-items: center;
}

.flex_sa a {
  color: rgba(0, 0, 0, 0.88);
  transition: color 0.3s;
}

.flex_sa a.is-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
  cursor: not-allowed;
  pointer-events: none;
}

.flex_sa .text_danger {
  color: #ff4d4f;
}

.enterprise-link {
  color: #1890ff;
  cursor: pointer;
}

.product-thumb-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
}

.product-thumb-placeholder {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background-color: #f0f0f0;
  color: #999;
  font-size: 12px;
}
</style>
